import React from 'react';

import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import NotificationBell from 'components/notifications/NotificationBell';

export const MOBILE_TOP_BAR_HEIGHT = 56;

interface MobileTopBarProps {
  title: React.ReactNode;
  onOpenMenu: () => void;
}

const MobileTopBar = ({ title, onOpenMenu }: MobileTopBarProps) => (
  <AppBar
    position="fixed"
    elevation={0}
    sx={{
      backgroundColor: 'background.paper',
      color: 'text.primary',
      borderBottom: '1px solid',
      borderColor: 'divider',
      zIndex: (theme) => theme.zIndex.appBar,
      pt: 'env(safe-area-inset-top)',
    }}
  >
    <Toolbar
      sx={{
        minHeight: `${MOBILE_TOP_BAR_HEIGHT}px !important`,
        px: 2,
        display: 'grid',
        gridTemplateColumns: '40px minmax(0, 1fr) 40px',
        alignItems: 'center',
        columnGap: 1,
      }}
    >
      <IconButton
        onClick={onOpenMenu}
        aria-label="Abrir menú"
        edge="start"
        disableRipple
        sx={{ color: 'text.primary' }}
      >
        <MenuIcon />
      </IconButton>

      {typeof title === 'string' ? (
        <Typography
          variant="h2"
          component="h1"
          noWrap
          sx={{ color: 'text.primary', fontSize: 18, fontWeight: 500, textAlign: 'center', minWidth: 0 }}
        >
          {title}
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: 0 }}>{title}</Box>
      )}

      <Box sx={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <NotificationBell collapsed />
      </Box>
    </Toolbar>
  </AppBar>
);

export default MobileTopBar;
